import { useFormik } from "formik";
import * as Yup from 'yup';
import { RefundsRequest } from "../../../modules/Refunds/types/refunds-response";
import { RefundStatus } from "../../../modules/Refunds/types/refund-status";

// Esquema de validación
export const refundRequestValidationSchema = Yup.object({
    dependency_id: Yup.string().required('Requerido'),
    location_id: Yup.string().required('Requerido'),
    new_responsible_id: Yup.string().nullable(),
    new_dependency_id: Yup.string().nullable(),
    justification: Yup.string().nullable().max(100, 'Digitar máximo 100 caracteres'),
    observations: Yup.string().nullable().max(500, 'Digitar máximo 500 caracteres'),
    refounds_type: Yup.string().required('Tipo de solicitud es Requerido'),
  });

  export const refundAnnulValidationSchema = Yup.object({
    observations: Yup.string().max(500 , 'Digitar máximo 500 caracteres').required('Observacion es Requerido'),
  });
  
  // Hook customizado
  interface UseRefundRequestFormikProps {
    onSubmit: (values: Partial<RefundsRequest>) => void;
  }
  
  export const useRefundAnnul = ({onSubmit}: any) => {
    return useFormik<Partial<RefundsRequest>>({
      initialValues: {
        id: 0,
        observations: ''
      },
      validationSchema: refundAnnulValidationSchema,
      onSubmit,
    })
  }
  const useRefundRequestFormik = ({ onSubmit }: UseRefundRequestFormikProps) => {
    return useFormik<Partial<RefundsRequest>>({
      initialValues: {
        dependency_id: '',
        location_id: '',
        new_responsible_id: '',
        new_dependency_id: '',
        status_id: RefundStatus.NUEVO,
        justification: '',
        observations: '',
        refounds_type: '',
      },
      validationSchema: refundRequestValidationSchema,
      onSubmit,
    });
  };
  
  export default useRefundRequestFormik;